<template>
  <div class="pop-txt-wrap pd-vertical-8">
    <div class="tit-h5">
      <i18n-t keypath="auto_topup_plan_only" scope="global">
        <template #plan>
          <span class="primary">Pro</span>
        </template>
      </i18n-t>
    </div>
    <p class="dim">{{ t('upgrade_pro_auto_topup_benefit') }}</p>
  </div>
</template>

<script setup lang="ts">
const { t } = useI18n();
</script>

<style scoped lang="scss">
.pop-txt-wrap {
  text-align: center;
  display: flex;
  flex-direction: column;
  gap: $size-s;
  align-items: center;
  div {
    word-break: keep-all;
    line-height: 130%;
  }
  p {
    max-width: 280px;
  }
}
</style>
